import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { UpdateAllergiesRequest, User } from "@/api/types";
import { assertCurrentSession, sessionRevision } from "@/lib/session-request-scope";

export function useUpdateAllergies() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateAllergiesRequest) =>
      api.patch("me/allergies", { json: data }).json<User>(),
    onSuccess: async (data) => {
      const revision = sessionRevision();
      await queryClient.cancelQueries({ queryKey: ["me"], exact: true });
      assertCurrentSession(revision);
      queryClient.setQueryData<User | null>(["me"], (user) =>
        user?.id === data.id ? { ...user, allergies: data.allergies } : user,
      );
    },
  });
}
